// extracted by mini-css-extract-plugin
export default {"accordion":"E28RDW","accordion__item":"zHKr8S","last-border":"VNVrbg"};